// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TOOLTIP ||============================== //

export default function Tooltip(theme: Theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: 'var(--nv-text-on-inverse)',
          backgroundColor: 'var(--nv-bg-inverse)'
        },
        arrow: {
          color: 'var(--nv-bg-inverse)'
        }
      }
    }
  };
}
